import ProductPhotoGallery from './ProductPhotoGallery'

export default ProductPhotoGallery
